<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
  </div>
</div>
